export class Cessao {
  public id!: number | string | null;
  public idFidc!: number | string | null;
  public codigo!: string;
  public nome!: string;
  public dtInclusao!: Date;
  public tipoRisco!: number;
  public taxa!: number;
  public valor!: number;
}